<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--change-request change-request-widget">
        <div class="card-header">
            <h6 class="fw-bold mb-0 dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.changeRequest"></span>
                <span>{{ $t('Change Request') }}</span>
            </h6>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive change-request-widget__table-wrap">
                <table class="table change-request-widget-table">
                    <thead>
                        <tr>
                            <th>{{ $t('S/N') }}</th>
                            <th>{{ $t('CR No') }}</th>
                            <th>{{ $t('Description') }}</th>
                            <th>{{ $t('Type') }}</th>
                            <th>{{ $t('Date Initiated') }}</th>
                            <th>{{ $t('Initiated By') }}</th>
                            <th>{{ $t('Schedule Impact') }}</th>
                            <th>{{ $t('Budget Cost') }} ({{ currencySign }})</th>
                            <th>{{ $t('Cost') }} ({{ currencySign }})</th>
                            <th>{{ $t('Reason for Change') }}</th>
                            <th>{{ $t('Status') }}</th>
                            <th class="dashboard-widget-table__actions">{{ $t('Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="data.length==0">
                            <td class="text-center dashboard-widget__empty-state" colspan="12">{{ $t('No data Found') }}</td>
                        </tr>
                        <tr v-for="(item,key) in data" :key="key">
                            <td> {{ key + 1 }}</td>
                            <td class="change-request-widget-table__cr"> 
                                <a :href="changeRequestUrl" class="link-style-custom"> 
                                    {{ item.crNo }} 
                                </a> 
                            </td>
                            <td class="change-request-widget-table__description">{{ item.description || '-' }}</td>
                            <td>{{ item.type || '-' }}</td>
                            <td>{{ ReformatDate(item.dateInitiated) }}</td>
                            <td>{{ item.initiatedBy || '-' }}</td>
                            <td>{{ item.scheduleImpact || '-' }}</td>
                            <td>{{ ReformatNumber(item.budgetCost) }}</td>
                            <td :class="{ 'text-danger' : item.cost < 0 }">{{ ReformatNumber(item.cost) }}</td>
                            <td>{{ item.reasonForChange || '-' }}</td>
                            <td class="change-request-widget-table__status">
                                <span :class="['change-request-widget__status', GetStatusClass(item.statusName)]">{{ item.statusName || '-' }}</span>
                            </td>
                            <td class="change-request-widget-table__actions dashboard-widget-table__actions">
                                <a :href="changeRequestUrl" :title="$t('View')" :aria-label="$t('View')">
                                    <i class="fa-regular fa-eye" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="dashboard-widget__footer dashboard-widget__footer--end"> <a :href="changeRequestUrl" class="dashboard-widget__link">{{ $t('View All') }}</a></div>
        </div>
    </div>
</template>


<script>
import {DashboardGetProjectChangeRequest} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import 'dotenv/config'
export default {
    name : 'ChangeRequestList',
    props : ['projectInfo'],
    data(){
        return {
            data : [],
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            sidebarSvg
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetProjectChangeRequest(self.projectInfo._id)
        if(!response)
            return
        self.data = self.NormalizeChangeRequests(response)
    },
    methods :{
        ReformatNumber,
        ReformatDate,
        NormalizeChangeRequests(response){
            const rawData = Array.isArray(response) ? response : (response.data || response.docs || response.items || [])
            if(!Array.isArray(rawData)){
                return []
            }
            return rawData.map(item => ({
                id : item.id || item._id || item.changeRequestId,
                crNo : item.crNo || item.crNumber || item.changeRequestNo || item.changeRequestNumber || item.number || '-',
                description : item.description || item.scopeDescription || item.title || '-',
                type : item.type || item.typeName || item.changeRequestType || item.changeRequestTypeName || '-',
                dateInitiated : item.dateInitiated || item.initiatedDate || item.createdAt || item.createdDate,
                initiatedBy : item.initiatedBy || item.initiatedByName || item.createdBy || item.createdByName || '-',
                scheduleImpact : item.scheduleImpact || item.scheduleImpactName || '-',
                budgetCost : Number(item.budgetCost ?? item.budgetCostTotal ?? item.expectedAmount ?? item.submittedAmount ?? 0),
                cost : Number(item.cost ?? item.actualCost ?? item.actualAmount ?? item.approvedAmount ?? 0),
                reasonForChange : item.reasonForChange || item.reason || item.changeReason || '-',
                statusName : item.statusName || item.statusLabel || item.statusText || '-'
            }))
        },
        GetStatusClass(statusName){
            const normalized = String(statusName || '').toLowerCase()
            if(normalized.indexOf('pending') > -1 || normalized.indexOf('draft') > -1){
                return 'change-request-widget__status--pending'
            }
            if(normalized.indexOf('approved') > -1){
                return 'change-request-widget__status--approved'
            }
            if(normalized.indexOf('reject') > -1 || normalized.indexOf('revision') > -1){
                return 'change-request-widget__status--danger'
            }
            return 'change-request-widget__status--neutral'
        }
    },
    computed : {
        changeRequestUrl(){
            return this.dotNetUrl + '/change-requestV2/' + this.projectInfo.projectOldId
        },
        currencySign(){
            return (this.projectInfo.currencyId && this.projectInfo.currencyId.sign) || 'S$'
        }
    }
    
} 
</script>

<style scoped>
.change-request-widget {
    --change-request-accent: #6d0075;
    --change-request-accent-dark: #520058;
    --change-request-header: #e7ccd9;
    --change-request-row-soft: #f7eff7;
    --change-request-row-plain: #ffffff;
    --change-request-row-muted: #f1e7f0;
    border: 0;
    background: #ffffff;
}

.change-request-widget__table-wrap {
    overflow-x: auto;
    border: 0 !important;
    background: #ffffff;
}

.change-request-widget-table {
    min-width: 82rem;
    margin: 0;
    border-collapse: collapse;
    color: #1e1b16;
    font-family: "Albert Sans", Arial, sans-serif;
    font-size: 0.82rem;
}

.change-request-widget-table thead th {
    border: 0 !important;
    border-bottom: 2px solid var(--change-request-accent) !important;
    color: var(--change-request-accent) !important;
    background: var(--change-request-header) !important;
    font-size: 0.76rem;
    font-weight: 800;
    line-height: 1.2;
    padding: 0.85rem 1rem;
    white-space: nowrap;
}

.change-request-widget-table td {
    border-color: #ded3df !important;
    color: #1e1b16 !important;
    font-weight: 600;
    padding: 0.85rem 1rem;
    vertical-align: middle;
}

.change-request-widget-table tbody tr > td:nth-child(odd) {
    background: var(--change-request-row-soft) !important;
}

.change-request-widget-table tbody tr > td:nth-child(even) {
    background: var(--change-request-row-plain) !important;
}

.change-request-widget-table tbody tr:nth-child(even) > td:nth-child(odd) {
    background: var(--change-request-row-muted) !important;
}

.change-request-widget-table__cr {
    min-width: 9rem;
}

.change-request-widget-table__cr a {
    color: #007bff !important;
    font-weight: 800;
    text-decoration: none !important;
}

.change-request-widget-table__description {
    min-width: 14rem;
    max-width: 18rem;
    white-space: normal;
}

.change-request-widget-table__status,
.change-request-widget-table__actions {
    text-align: center;
    white-space: nowrap;
}

.change-request-widget__status {
    display: inline-flex;
    min-width: 6.5rem;
    min-height: 1.55rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    padding: 0.25rem 0.8rem;
    font-size: 0.72rem;
    font-weight: 800;
    line-height: 1;
    white-space: nowrap;
}

.change-request-widget__status--pending {
    border: 1px solid #0d75a7;
    color: #0d5075;
    background: #d9edf7;
}

.change-request-widget__status--approved {
    color: #0d8d67;
    background: #d8ebe6;
}

.change-request-widget__status--danger {
    color: #b0005b;
    background: #f7dddd;
}

.change-request-widget__status--neutral {
    color: var(--change-request-accent);
    background: #f3e3f2;
}

.change-request-widget-table__actions a {
    display: inline-flex;
    width: 1.55rem;
    height: 1.55rem;
    align-items: center;
    justify-content: center;
    color: #777777 !important;
    font-size: 1rem;
    text-decoration: none !important;
}

.change-request-widget-table__actions a:hover,
.change-request-widget-table__actions a:focus {
    color: var(--change-request-accent) !important;
}

.change-request-widget .dashboard-widget__footer {
    padding: 0.9rem 0.85rem 0.85rem;
}

@media (max-width: 767.98px) {
    .change-request-widget-table {
        min-width: 72rem;
    }
}
</style>
